import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_9 implements Validator {

	public static id = 'CTRL_9';
	private message = 'error.ctr_9';


	public LOG: LogService = new LogService(CTRL_9);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_9.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const nomWithStepId = map.get(ctrl.value.rgCtrls.nom);
				const prenomWithStepId = map.get(ctrl.value.rgCtrls.prenom);
				const foncWithStepId = map.get(ctrl.value.rgCtrls.fonc);
				const civiliteWithStepId = map.get(ctrl.value.rgCtrls.civilite);
				const nomCtrl = form.controls[nomWithStepId];
				const prenomCtrl = form.controls[prenomWithStepId];
				const foncCtrl = form.controls[foncWithStepId];
				const civiliteCtrl = form.controls[civiliteWithStepId];

				if (
					(nomCtrl && nomCtrl.value === '') ||
					(prenomCtrl && prenomCtrl.value === '') ||
					(foncCtrl && foncCtrl.value === '') ||
					(civiliteCtrl && civiliteCtrl.value === '')) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}
}
